import { Avatar, Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ElevatedCard } from "../../../components/elevated-card";
import { ConversationsFeature } from "../../../features/conversations";
import { AppRouteConstants } from "../../../navigations/routes";
import { useState } from "react";

import { icons } from "../../../icons";

export const JobseekerBasicCard = ({ jobseeker }) => {
  return (
    <ElevatedCard
      sx={{
        p: { xs: "1rem", md: "1.6rem" },
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "flex-start",
          mr: "1rem",
        }}
      >
        <Avatar
          src={jobseeker?.image}
          sx={{
            width: "4.4rem",
            height: "4.4rem",
            mb: { xs: "0.8rem", md: "0rem" },
          }}
        >
          {jobseeker?.name[0]}
        </Avatar>
        <Box width="2rem" />
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h5" fontWeight="bold">
            {jobseeker?.name}
          </Typography>
          <Typography variant="body1">{jobseeker?.role}</Typography>

          <Box sx={{ display: "flex", alignItems: "center", mt: "0.6rem" }}>
            {icons.email({
              sx: { width: "1.2rem", height: "1.2rem", mr: "0.4rem" },
            })}
            <Typography variant="body2">{jobseeker?.email}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mt: "0.6rem" }}>
            {icons.phone({
              sx: { width: "1.2rem", height: "1.2rem", mr: "0.4rem" },
            })}
            <Typography variant="body2">{jobseeker?.phone}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mt: "0.6rem" }}>
            {icons.map({
              sx: { width: "1.2rem", height: "1.2rem", mr: "0.4rem" },
            })}
            <Typography variant="body2">{jobseeker?.homebase}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mt: "0.6rem" }}>
            {icons.location({
              sx: { width: "1.2rem", height: "1.2rem", mr: "0.4rem" },
            })}
            <Typography variant="caption" sx={{ color: "grey" }}>
              {`${jobseeker?.city}, ${jobseeker?.country}`}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: "0.6rem",
            }}
          >
            {icons.person({
              sx: {
                width: "1.2rem",
                height: "1.2rem",
                mr: "0.4rem",
                alignSelf: "flex-start",
                mt: "0.4rem",
              },
            })}
            <About jobseeker={jobseeker} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: "1rem", md: "1.6rem" },
          right: { xs: "1rem", md: "1.6rem" },
        }}
      >
        <StartConversationButton jobseekerId={jobseeker?.profileId} />
      </Box>
    </ElevatedCard>
  );
};

const StartConversationButton = ({ jobseekerId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      const { id } = await ConversationsFeature.startNewConversation({
        recipientId: jobseekerId,
      })(dispatch);

      navigate(`${AppRouteConstants.viewConversation}?conversationId=${id}`);
    } catch (error) {}
  };

  return (
    <Button sx={{ borderRadius: "2.5rem" }} onClick={handleClick}>
      Message
    </Button>
  );
};

const About = ({ jobseeker }) => {
  const [showFullText, setShowFullText] = useState(false);

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };

  const maxLength = 100;
  const text = showFullText
    ? jobseeker?.about
    : jobseeker?.about?.slice(0, maxLength);

  return (
    <Typography
      variant="body2"
      sx={{ mt: "0.4rem", maxWidth: "80rem" }}
      whiteSpace={"pre-line"}
      onClick={toggleShowFullText}
    >
      {text}
      {text?.length >= 100 && !showFullText ? "..." : ""}

      {text?.length >= 100 && (
        <Typography
          variant="body2"
          component={"span"}
          sx={{ textDecoration: "underline", cursor: "pointer", ml: "0.4rem" }}
        >
          {showFullText ? "Read Less" : "Read More"}
        </Typography>
      )}
    </Typography>
  );
};
